import { useState, useEffect } from 'react';
import { fetchAPI, UrlParams } from '../services/strapi';

function mapResponse(result: any, urlPrefix = "") {
  const dateList = `${result.attributes.data_julgamento}`.split('-');
  // const datePubli = `${result.attributes.data_publicacao}`.split('-');
  return {
    title: result.attributes.title,
    author: result.attributes.author,
    date: dateList.length === 3? `${dateList[2]}/${dateList[1]}/${dateList[0]}` : result.attributes.data_julgamento,
    // publication_date: datePubli.length === 3? `${datePubli[2]}/${datePubli[1]}/${datePubli[0]}` : result.attributes.data_publicacao,
    // number: result.attributes.numero,
    // agency: result.attributes.orgao,
    // index: result.attributes.indice,
    // court: result.attributes.tribunal,
    pdf_url: result.attributes.url_arquivo
  };
}

export type Search = {
  search_text?: string;
  initialDateJulgamento?: string;
  finalDateJulgamento?: string;
  initialDatePublicacao?: string;
  finalDatePublicacao?: string;
  numero?: string;
  orgao?: string;
  relatoria?: string;
  tribunal?: string[];
  indice?: string;
}

function mountFilter(array: any[], field: string | undefined | null, fieldTitle: string, operator: string = "$containsi") {
  if(field) {
    let filter: any = {};
    filter[fieldTitle] = {};
    filter[fieldTitle][operator] = field;

    array.push(filter);
  }
}

function mountCaseSensitiveFilter(array: any[], field: string | undefined | null, fieldTitle: string, operator: string = "$containsi") {
  if(field) {
    const tempArray: any[] = [];
    mountFilter(tempArray, field, fieldTitle, operator);
    mountFilter(tempArray, `${field}`.toUpperCase(), fieldTitle, operator);
    mountFilter(tempArray, `${field}`.toLowerCase(), fieldTitle, operator);

    array.push({
      $or: tempArray
    })
  }
}

function mapFilter(search: Search) {
  let filters: any = {};

  let or: any[] = [];
  if(search.search_text) {

    mountCaseSensitiveFilter(or, search.search_text, 'search_text');
    mountCaseSensitiveFilter(or, search.search_text, 'title');
    mountCaseSensitiveFilter(or, search.search_text, 'author');
    mountCaseSensitiveFilter(or, search.search_text, 'numero');
    mountCaseSensitiveFilter(or, search.search_text, 'orgao');
    mountCaseSensitiveFilter(or, search.search_text, 'relatoria');
    mountCaseSensitiveFilter(or, search.search_text, 'indice');

    filters.$or = or;
  }

  let and: any[] = []
  mountFilter(and, search.initialDateJulgamento, 'data_julgamento', '$gte');
  mountFilter(and, search.finalDateJulgamento, 'data_julgamento', '$lte');
  mountFilter(and, search.initialDatePublicacao, 'data_publicacao', '$gte');
  mountFilter(and, search.finalDatePublicacao, 'data_publicacao', '$lte');

  mountCaseSensitiveFilter(and, search.numero, 'numero');
  mountCaseSensitiveFilter(and, search.indice, 'indice');
  
  // mountCaseSensitiveFilter(and, search.orgao, 'orgao');
  

  if(search.relatoria) {
    const tempOrList: any[] = [];

    mountCaseSensitiveFilter(tempOrList, search.relatoria, 'relatoria');
    mountCaseSensitiveFilter(tempOrList, search.relatoria, 'author');

    and.push({
      $or: tempOrList
    });
  }

  if(search?.tribunal && search?.tribunal?.length ) {
    and.push({
      tribunal: {
        $in: search.tribunal.reduce((previous: string[], current: string) => previous.concat(mapTribunalValues(current)) , [])
      }
    });
  }
  filters.$and = and;


  return filters
}

function mapTribunalValues(initSearch: string): string[] {
  switch (initSearch) {
    case "STF":
      return ["STF"]
    case "STJ":
      return ["STJ"]
    case "TRF":
      return ["TRFs", "TRF"]
    case "Tribunais de Justiça":
      return ["Tribunais de Justiça", "Tribunal de Justiça"];
    case "TSE":
      return ["TSE", "TSEs"];
    case "TST":
      return ["Justiça Trabalhista", "Justiças Trabalhistas", "TST"];
    case "Justiça Trabalhista":
      return ["Justiça Trabalhista", "Justiças Trabalhistas", "TST"];
    case "Enunciados do CJF":
      return ["Enunciado", "Enunciados", "Enunciados do CJF", "Enunciado do CJF"]
    case "Súmulas":
      return ["Súmulas", "Súmula"];
    case "Decisões do CNDA":
      return ["Decisão", "Decisões", "Decisões do CNDA", "Decisão do ONDA"];
    case "Outros":
      return ["Outro", "Outros"];
    default:
      return []
  }
}

export function mapInitialSearch(initSearch: string, array: any[]|null = null) {
  switch (initSearch) {
    case "stf":
      array && mountFilter(array, "STF", 'tribunal')
      return "STF"
    case "stj":
      array && mountFilter(array, "STJ", 'tribunal')
      return "STJ"
    case "trf":
      array && mountFilter(array, "TRFs", 'tribunal')
      array && mountFilter(array, "TRF", 'tribunal')
      return "TRF"
    case "tribunais-justica":
      array && mountCaseSensitiveFilter(array, "Tribunais de Justiça", 'tribunal')
      array && mountCaseSensitiveFilter(array, "Tribunal de Justiça", 'tribunal')
      return "Tribunais de Justiça"
    case "justica-trabalhista":
      array && mountCaseSensitiveFilter(array, "Justiça Trabalhista", 'tribunal')
      array && mountCaseSensitiveFilter(array, "Justiças Trabalhistas", 'tribunal')
      array && mountCaseSensitiveFilter(array, "TST", 'tribunal')
      array && mountCaseSensitiveFilter(array, "TSTs", 'tribunal')
      return "TST"
    case "tst":
      array && mountCaseSensitiveFilter(array, "Justiça Trabalhista", 'tribunal')
      array && mountCaseSensitiveFilter(array, "Justiças Trabalhistas", 'tribunal')
      array && mountCaseSensitiveFilter(array, "TST", 'tribunal')
      array && mountCaseSensitiveFilter(array, "TSTs", 'tribunal')
      return "TST"
    case "tse":
      array && mountCaseSensitiveFilter(array, "TSEs", 'tribunal')
      array && mountCaseSensitiveFilter(array, "TSE", 'tribunal')
      return "TSE"
    case "enunciados-cjf":
      array && mountCaseSensitiveFilter(array, "Enunciado", 'tribunal')
      return "Enunciados do CJF"
    case "sumulas":
      array && mountCaseSensitiveFilter(array, "Súmulas", 'tribunal')
      array && mountCaseSensitiveFilter(array, "Súmula", 'tribunal')
      return "Súmulas"
    case "decisoes-cnda":
      array && mountCaseSensitiveFilter(array, "Decisão", 'tribunal')
      array && mountCaseSensitiveFilter(array, "Decisões", 'tribunal')
      array && mountCaseSensitiveFilter(array, "Decisões do CNDA", 'tribunal')
      array && mountCaseSensitiveFilter(array, "Decisão do ONDA", 'tribunal')
      return "Decisões do CNDA"
    case "decisoes-onda":
      array && mountCaseSensitiveFilter(array, "Decisão", 'tribunal')
      array && mountCaseSensitiveFilter(array, "Decisões", 'tribunal')
      array && mountCaseSensitiveFilter(array, "Decisões do CNDA", 'tribunal')
      array && mountCaseSensitiveFilter(array, "Decisão do ONDA", 'tribunal')
      return "Decisões do CNDA"
    case "outros":
      array && mountCaseSensitiveFilter(array, "Outro", 'tribunal')
      array && mountCaseSensitiveFilter(array, "Outros", 'tribunal')
      return "Outros"
    default:
      return ""
  }
}

export type Response = {
  results: any[],
  pagination: {
    page: number,
    pageSize: number,
    pageCount: number,
    total: number
	}
}

export function useDecisions(initialSearch: string = ''): Response {
  const initialData: Response = {
    results: [], 
    pagination: {
      page: -1,
      pageCount: -1,
      pageSize: -1,
      total: -1
    }
  }
  const [data, setData] = useState<Response>(initialData);
  
  const fetchData = async () => {
    let query: UrlParams = {
      populate: "*",
      pagination: {
        page: 1,
        pageSize: 10
      },
      sort: ['data_julgamento:desc', 'data_publicacao:desc', 'title:desc'],
    };

    if (mapInitialSearch(initialSearch)) {
      let or: any[] = [];
      mapInitialSearch(initialSearch, or);
      query.filters = {
        $or: or
      }
    }

    setData(await makeRequest(query));
  }

  useEffect(() => {
    //if(data?.results?.length || data.pagination.pageSize === 10) return;
    fetchData();
  }, [data.pagination.page, initialSearch]); // eslint-disable-line react-hooks/exhaustive-deps

  return data;
};

export const orderObjects = [
  {
    frontValue: 'Mais Recentes',
    backValue: ['data_julgamento:desc', 'data_publicacao:desc', 'title:desc']
  },
  {
    frontValue: 'Mais Antigas',
    backValue:  ['data_julgamento:asc', 'data_publicacao:asc', 'title:asc']
  },
  {
    frontValue: 'Alfabética A - Z',
    backValue: ['title:asc', 'data_julgamento:asc', 'data_publicacao:asc']
  },
  {
    frontValue: 'Alfabética Z - A',
    backValue: ['title:desc', 'data_julgamento:desc', 'data_publicacao:desc']
  }
]

export async function getDecisions(search: Search | null = null, page: number = 1, order: string[] = orderObjects[0].backValue): Promise<Response> {
  
  let query: UrlParams = {
    populate: "*",
    pagination: {
      page: page,
      pageSize: 10
    },
    sort: order,
  };

  if(search) {
    query.filters = mapFilter(search);
  }
  return await makeRequest(query);
}


async function makeRequest(query: any): Promise<Response> {
  const response = await fetchAPI("/decisions", query);
    return {
      results: response.data.map((item: any) => mapResponse(item)),
      pagination: response.meta.pagination
    };
}